import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import LockedSlot from "@/modules/club-grounds/components/LockedSlot.vue";
import UnlockedSlot from "@/modules/club-grounds/components/UnlockedSlot.vue";
import AvailableSlot from "@/modules/club-grounds/components/AvailableSlot.vue";
import DevelopedSlot from "@/modules/club-grounds/components/DevelopedSlot.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'GroundSlot',
  props: {
    groundSlot: null,
    team: null
  },
  setup(__props) {
    const props = __props;
    const slotComponent = computed(() => {
      if (props.groundSlot.locked) {
        return LockedSlot;
      }
      if (props.groundSlot.available && !props.groundSlot.type) {
        return AvailableSlot;
      }
      if (props.groundSlot.type) {
        return DevelopedSlot;
      }
      return UnlockedSlot;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_resolveDynamicComponent(_unref(slotComponent)), _mergeProps(_ctx.$attrs, {
        team: __props.team,
        "ground-slot": __props.groundSlot
      }), null, 16, ["team", "ground-slot"]);
    };
  }
});